export function createLeadCapturedPersonaState(nudgeData) {
    return {
        nudgeOfferText: {
            text: nudgeData?.nudgeOfferText?.customizeProperties?.text
                ?.propertyValue,
            textColor:
                nudgeData?.nudgeOfferText?.customizeProperties?.textColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeOfferText?.customizeProperties?.fontStyle
                    ?.propertyValue,
            isExpiryTimer: nudgeData?.nudgeOfferText?.customizeProperties?.isExpiryTimer?.propertyValue,
            minutes: nudgeData?.nudgeOfferText?.customizeProperties?.minutes?.propertyValue,
        },
        nudgeCouponCode: {
            textColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.textColor
                    ?.propertyValue,
            backgroundColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeCouponCode?.customizeProperties?.fontStyle
                    ?.propertyValue,
            borderStyle:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderStyle
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderColor
                    ?.propertyValue,
            borderWidth:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderWidth
                    ?.propertyValue,
            borderRadius:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderRadius
                    ?.propertyValue,
            display:
                nudgeData?.nudgeCouponCode?.customizeProperties?.display
                    ?.propertyValue,
        },
        nudgeCopyCode: {
            text: nudgeData?.nudgeCopyCode?.customizeProperties?.text
                ?.propertyValue,
            textColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.textColor
                    ?.propertyValue,
            backgroundColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeCopyCode?.customizeProperties?.fontStyle
                    ?.propertyValue,
            borderStyle:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderStyle
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderColor
                    ?.propertyValue,
            borderWidth:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderWidth
                    ?.propertyValue,
            borderRadius:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderRadius
                    ?.propertyValue,
            ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
                href: nudgeData.nudgeCopyCode.customizeProperties.href?.propertyValue,
            })
        },
        nudge: {
            backgroundColor:
                nudgeData?.nudge?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudge?.customizeProperties?.borderColor?.propertyValue,
            borderStyle:
                nudgeData?.nudge?.customizeProperties?.borderStyle?.propertyValue,
            borderWidth:
                nudgeData?.nudge?.customizeProperties?.borderWidth?.propertyValue,
            borderRadius:
                nudgeData?.nudge?.customizeProperties?.borderRadius?.propertyValue,
            desktopNudgePosition: {
                top: nudgeData?.nudge?.nudgePosition?.desktop?.top,
                left: nudgeData?.nudge?.nudgePosition?.desktop?.left,
            },
            mobileNudgePosition: {
                top: nudgeData?.nudge?.nudgePosition?.mobile?.top,
            },
        },
        nudgeShowing: {
            allowed: nudgeData?.nudgeShowing?.customizeProperties?.allowed?.propertyValue,
            prohibited: nudgeData?.nudgeShowing?.customizeProperties?.prohibited?.propertyValue,
            status: nudgeData?.nudgeShowing?.customizeProperties?.status?.propertyValue,
            firstTimeNudgeShown: nudgeData?.nudgeShowing?.customizeProperties?.firstTimeNudgeShown?.propertyValue,
            sensitivity: nudgeData?.nudgeShowing?.customizeProperties?.sensitivity?.propertyValue,
            device: nudgeData?.nudgeShowing?.customizeProperties?.device?.propertyValue ?? "all",
            Geolocation: nudgeData?.nudgeShowing?.customizeProperties?.Geolocation?.propertyValue,
            nudgeTimeout: nudgeData?.nudgeShowing?.customizeProperties?.nudgeTimeout?.propertyValue,
            audience: nudgeData?.nudgeShowing?.customizeProperties?.audience?.propertyValue,
            view_mode: nudgeData?.nudgeShowing?.customizeProperties?.view_mode?.propertyValue,
            ...(nudgeData.nudgeShowing.customizeProperties.startDate && {
                startDate: nudgeData.nudgeShowing.customizeProperties.startDate?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
                endDate: nudgeData.nudgeShowing.customizeProperties.endDate?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.priority && {
                priority: nudgeData.nudgeShowing.customizeProperties.priority?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
                nudgeActiveDays: nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
                GeoZipcodes: nudgeData.nudgeShowing.customizeProperties.GeoZipcodes?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes && {
                BlacklistedZipcodes: nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
                seoKeyword: nudgeData.nudgeShowing.customizeProperties.seoKeyword?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
                ipBasedNudgeControl: nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
                firstTimeUserCheckingOptions: nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.allowWebsiteClick && {
                allowWebsiteClick: nudgeData.nudgeShowing.customizeProperties.allowWebsiteClick?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.showMultipleTimesInSession && {
                showMultipleTimesInSession: nudgeData.nudgeShowing.customizeProperties.showMultipleTimesInSession?.propertyValue,
            }),
        },
        nudgePosition: {
            placement: nudgeData?.nudgePosition?.customizeProperties?.placement?.propertyValue,
            margin_left: nudgeData?.nudgePosition?.customizeProperties?.margin_left?.propertyValue,
            margin_top: nudgeData?.nudgePosition?.customizeProperties?.margin_top?.propertyValue,
            margin_right: nudgeData?.nudgePosition?.customizeProperties?.margin_right?.propertyValue,
            margin_bottom: nudgeData?.nudgePosition?.customizeProperties?.margin_bottom?.propertyValue,
        },
        nudgeImages: {
            image:
                nudgeData?.nudgeImages?.customizeProperties?.image
                    ?.propertyValue,
            borderStyle:
                nudgeData?.nudgeImages?.customizeProperties?.borderStyle
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudgeImages?.customizeProperties?.borderColor
                    ?.propertyValue,
            borderWidth:
                nudgeData?.nudgeImages?.customizeProperties?.borderWidth
                    ?.propertyValue,
            borderRadius:
                nudgeData?.nudgeImages?.customizeProperties?.borderRadius
                    ?.propertyValue,
            display:
                nudgeData?.nudgeImages?.customizeProperties?.display
                    ?.propertyValue,
        },
        nudgeClosed: {
            fontSize: nudgeData?.nudgeClosed?.customizeProperties?.fontSize?.propertyValue,
            textColor: nudgeData?.nudgeClosed?.customizeProperties?.textColor?.propertyValue,
            topPosition: nudgeData?.nudgeClosed?.customizeProperties?.topPosition?.propertyValue,
            rightPosition: nudgeData?.nudgeClosed?.customizeProperties?.rightPosition?.propertyValue,
            positionMode: nudgeData?.nudgeClosed?.customizeProperties?.positionMode?.propertyValue,
            shape: nudgeData?.nudgeClosed?.customizeProperties?.shape?.propertyValue,
            width: nudgeData?.nudgeClosed?.customizeProperties?.width?.propertyValue,
            height: nudgeData?.nudgeClosed?.customizeProperties?.height?.propertyValue,
            padding: nudgeData?.nudgeClosed?.customizeProperties?.padding?.propertyValue,
            backgroundColor: nudgeData?.nudgeClosed?.customizeProperties?.backgroundColor?.propertyValue,
            borderColor: nudgeData?.nudgeClosed?.customizeProperties?.borderColor?.propertyValue,
            borderWidth: nudgeData?.nudgeClosed?.customizeProperties?.borderWidth?.propertyValue,
            borderStyle: nudgeData?.nudgeClosed?.customizeProperties?.borderStyle?.propertyValue,
            borderRadius: nudgeData?.nudgeClosed?.customizeProperties?.borderRadius?.propertyValue,
            shadowEnabled: nudgeData?.nudgeClosed?.customizeProperties?.shadowEnabled?.propertyValue,
            shadowColor: nudgeData?.nudgeClosed?.customizeProperties?.shadowColor?.propertyValue,
            shadowX: nudgeData?.nudgeClosed?.customizeProperties?.shadowX?.propertyValue,
            shadowY: nudgeData?.nudgeClosed?.customizeProperties?.shadowY?.propertyValue,
            shadowBlur: nudgeData?.nudgeClosed?.customizeProperties?.shadowBlur?.propertyValue,
            shadowSpread: nudgeData?.nudgeClosed?.customizeProperties?.shadowSpread?.propertyValue,
            display: nudgeData?.nudgeClosed?.customizeProperties?.display?.propertyValue,
        },
        nudgeTrafficSources: {
            referrerSites: nudgeData?.nudgeTrafficSources?.customizeProperties?.referrerSites?.propertyValue,
            queryParams: nudgeData?.nudgeTrafficSources?.customizeProperties?.queryParams?.propertyValue,
            excludeReferrerSites: nudgeData?.nudgeTrafficSources?.customizeProperties?.excludeReferrerSites?.propertyValue,
        },
        nudgeInputFields: {
            inputField1: [nudgeData?.nudgeInputFields?.customizeProperties?.inputField1?.propertyValue, nudgeData?.nudgeInputFields?.customizeProperties?.inputField1?.display, nudgeData?.nudgeInputFields?.customizeProperties?.inputField1?.isRequired],

            inputField2: [nudgeData?.nudgeInputFields?.customizeProperties?.inputField2?.propertyValue, nudgeData?.nudgeInputFields?.customizeProperties?.inputField2?.display, nudgeData?.nudgeInputFields?.customizeProperties?.inputField2?.isRequired],

            inputField3: [nudgeData?.nudgeInputFields?.customizeProperties?.inputField3?.propertyValue, nudgeData?.nudgeInputFields?.customizeProperties?.inputField3?.display, nudgeData?.nudgeInputFields?.customizeProperties?.inputField3?.isRequired],

            inputField4: [nudgeData?.nudgeInputFields?.customizeProperties?.inputField4?.propertyValue, nudgeData?.nudgeInputFields?.customizeProperties?.inputField4?.display, nudgeData?.nudgeInputFields?.customizeProperties?.inputField4?.isRequired]

        },
        ...(nudgeData?.nudgeDisclaimerText && {
            nudgeDisclaimerText: {
                display: nudgeData?.nudgeDisclaimerText?.customizeProperties?.display?.propertyValue,
                fontSize: nudgeData?.nudgeDisclaimerText?.customizeProperties?.fontSize?.propertyValue,
                fontStyle: nudgeData?.nudgeDisclaimerText?.customizeProperties?.fontStyle?.propertyValue,
                text: nudgeData?.nudgeDisclaimerText?.customizeProperties?.text?.propertyValue,
                textColor: nudgeData?.nudgeDisclaimerText?.customizeProperties?.textColor?.propertyValue,
            },
        }),
        ...(nudgeData?.thankYouOfferText && {
            thankYouOfferText: {
                text: nudgeData?.thankYouOfferText?.customizeProperties?.text
                    ?.propertyValue,
                textColor:
                    nudgeData?.thankYouOfferText?.customizeProperties?.textColor
                        ?.propertyValue,
                fontStyle:
                    nudgeData?.thankYouOfferText?.customizeProperties?.fontStyle
                        ?.propertyValue,
                isExpiryTimer: nudgeData?.thankYouOfferText?.customizeProperties?.isExpiryTimer?.propertyValue,
                minutes: nudgeData?.thankYouOfferText?.customizeProperties?.minutes?.propertyValue,
            }

        }),
        ...(nudgeData?.formSubmissionMedia && {
            formSubmissionMedia: {
                media:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.media
                        ?.propertyValue,
                mediaType:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.mediaType
                        ?.propertyValue,
                borderStyle:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.borderStyle
                        ?.propertyValue,
                borderColor:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.borderColor
                        ?.propertyValue,
                borderWidth:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.borderWidth
                        ?.propertyValue,
                borderRadius:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.borderRadius
                        ?.propertyValue,
                display:
                    nudgeData?.formSubmissionMedia?.customizeProperties?.display
                        ?.propertyValue,
            }
        }),
        ...(nudgeData?.thankYouButton && {
            thankYouButton: {
                text: nudgeData?.thankYouButton?.customizeProperties?.text
                    ?.propertyValue,
                textColor:
                    nudgeData?.thankYouButton?.customizeProperties?.textColor
                        ?.propertyValue,
                backgroundColor:
                    nudgeData?.thankYouButton?.customizeProperties?.backgroundColor
                        ?.propertyValue,
                fontStyle:
                    nudgeData?.thankYouButton?.customizeProperties?.fontStyle
                        ?.propertyValue,
                borderStyle:
                    nudgeData?.thankYouButton?.customizeProperties?.borderStyle
                        ?.propertyValue,
                borderColor:
                    nudgeData?.thankYouButton?.customizeProperties?.borderColor
                        ?.propertyValue,
                borderWidth:
                    nudgeData?.thankYouButton?.customizeProperties?.borderWidth
                        ?.propertyValue,
                borderRadius:
                    nudgeData?.thankYouButton?.customizeProperties?.borderRadius
                        ?.propertyValue,
            }
        }),
        ...(nudgeData?.nudgeDisclaimerText && {
            nudgeDisclaimerText: {
                display: nudgeData?.nudgeDisclaimerText?.customizeProperties?.display?.propertyValue,
                fontSize: nudgeData?.nudgeDisclaimerText?.customizeProperties?.fontSize?.propertyValue,
                fontStyle: nudgeData?.nudgeDisclaimerText?.customizeProperties?.fontStyle?.propertyValue,
                text: nudgeData?.nudgeDisclaimerText?.customizeProperties?.text?.propertyValue,
                textColor: nudgeData?.nudgeDisclaimerText?.customizeProperties?.textColor?.propertyValue,
            },
        }),
        ...(nudgeData?.formSubmissionDisclaimerText && {
            formSubmissionDisclaimerText: {
                display: nudgeData?.formSubmissionDisclaimerText?.customizeProperties?.display?.propertyValue,
                fontSize: nudgeData?.formSubmissionDisclaimerText?.customizeProperties?.fontSize?.propertyValue,
                fontStyle: nudgeData?.formSubmissionDisclaimerText?.customizeProperties?.fontStyle?.propertyValue,
                text: nudgeData?.formSubmissionDisclaimerText?.customizeProperties?.text?.propertyValue,
                textColor: nudgeData?.formSubmissionDisclaimerText?.customizeProperties?.textColor?.propertyValue,
            },
        }),
        ...(nudgeData?.nudgeLeadCapturedRecipientEmail && {
            nudgeLeadCapturedRecipientEmail: {
                text: nudgeData?.nudgeLeadCapturedRecipientEmail?.customizeProperties?.text?.propertyValue,
            },
        }),
        ...(nudgeData?.nudgeTutorialVideo && {
            nudgeTutorialVideo: {
                display: nudgeData?.nudgeTutorialVideo?.customizeProperties?.display
                    ?.propertyValue,
                text: nudgeData?.nudgeTutorialVideo?.customizeProperties?.text
                    ?.propertyValue,
                textColor:
                    nudgeData?.nudgeTutorialVideo?.customizeProperties?.textColor
                        ?.propertyValue,
                fontStyle:
                    nudgeData?.nudgeTutorialVideo?.customizeProperties?.fontStyle
                        ?.propertyValue,
                linkText: nudgeData?.nudgeTutorialVideo?.customizeProperties?.linkText?.propertyValue,
                linkTextColor: nudgeData?.nudgeTutorialVideo?.customizeProperties?.linkTextColor?.propertyValue,
                ...(nudgeData.nudgeTutorialVideo.customizeProperties.href && {
                    href: nudgeData.nudgeTutorialVideo.customizeProperties.href?.propertyValue,
                })
            },
        }),
        hasCustomHtml: !!nudgeData?.nudgeCustomHtmlDesign,
        useHtmlDesign: (nudgeData?.nudgeCustomHtmlDesign?.customizeProperties?.isActive?.propertyValue ?? nudgeData?.nudgeCustomHtmlDesign?.customizeProperties?.isActive) === "YES",
        htmlDesignCode: nudgeData?.nudgeCustomHtmlDesign?.customizeProperties?.htmlDesignCode?.propertyValue ?? nudgeData?.nudgeCustomHtmlDesign?.customizeProperties?.htmlDesignCode ?? "",
    }
}